
  /**
   * セールステータスに応じて要素の表示を制御
   * 計算結果をdata属性とクラスとして設定
   */
  document.addEventListener('DOMContentLoaded', () => {
    const buyButtonsBlock = document.querySelector('.buy-buttons-block')
    const status = getSaleTimeStatus(buyButtonsBlock);
    
    if (buyButtonsBlock) {
      const cartTextContent = buyButtonsBlock.querySelector('.add-to-cart-text__content');
      const cartButton = buyButtonsBlock.querySelector('.add-to-cart-button');
      // data属性にステータスを設定（他のJSからも参照可能）
      buyButtonsBlock.setAttribute('data-sale-status', status)
      // 状態を表現するクラスを追加（CSSで制御可能）
      buyButtonsBlock.classList.add(`add-${status}`);
      // ロード時のボタンのスタイル変化を隠すためのクラスを追加
      buyButtonsBlock.classList.add('add-loaded');
    }
  })